function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.0773 20.3213C12.6312 20.6498 12.2614 20.9114 12.0017 21.0918C11.7419 20.9114 11.3718 20.6497 10.9253 20.3211C10.0175 19.6532 8.79829 18.7121 7.54849 17.6175C6.29631 16.5208 5.02764 15.2823 4.01226 14.0205C2.98672 12.7461 2.27127 11.5107 2.04078 10.4186L2.03349 10.384L2.02298 10.3503C1.84714 9.78605 1.75 9.1829 1.75 8.55324C1.75 6.34779 2.90739 4.44595 4.59017 3.46307C5.37507 3.00851 6.26559 2.75 7.21295 2.75C8.89022 2.75 10.4006 3.55325 11.413 4.83681L12.0033 5.58513L12.5918 4.83546C13.5983 3.55344 15.1095 2.75 16.7844 2.75C17.735 2.75 18.6272 3.00883 19.4093 3.46284C21.0928 4.44744 22.25 6.34894 22.25 8.55324C22.25 9.18121 22.152 9.7853 21.9759 10.3503L21.9654 10.3839L21.9581 10.4184C21.7273 11.5107 21.0118 12.7462 19.9867 14.0207C18.9716 15.2825 17.7036 16.521 16.4521 17.6177C15.203 18.7123 13.9845 19.6534 13.0773 20.3213Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgFavorites = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavorites, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Favorites.8f7b85e2.svg";
export { ForwardRef as ReactComponent };